import firebase from '../firebase';
import { toArray } from '../../util';

const firestore = firebase.firestore();

export const getMetadata = async () => {
    try {
        const data = await firestore.collection('category_metadata_v2').get();
        return toArray(data);
    } catch (e) {
        console.log(e);
        return [];
    }
};

export const getAllCategories = async () => {
    try {
        let all = await firestore.collection('categories').get();
        all = toArray(all);

        const allTypes = toArray(await firestore.collection('sub_category_types').get());
        const typesByCategory = allTypes.reduce((result, type) => {
            if (!(type.categoryId in result)) {
                // eslint-disable-next-line no-param-reassign
                result[type.categoryId] = [];
            }
            result[type.categoryId].push({ id: type.id, name: type.name.toLowerCase() });
            return result;
        }, {});

        const mainCategories = all
            .filter((cat) => cat.parent_id === 'unset')
            .reduce(
                (result, cat) => ({
                    ...result,
                    [cat.id]: {
                        ...cat,
                        subCategories: [],
                        types: typesByCategory[cat.id] || [],
                    },
                }),
                {},
            );

        all.filter((cat) => cat.parent_id !== 'unset').forEach((cat) => {
            if (!(cat.parent_id in mainCategories)) {
                return;
            }

            mainCategories[cat.parent_id].subCategories.push({
                ...cat,
                types: typesByCategory[cat.id] || [],
            });
        });
        return Object.values(mainCategories);
    } catch (e) {
        console.log(e);
        return [];
    }
};

export function getCategoryById(categories, id) {
    const mainFound = categories.find((e) => e.id === id);
    if (mainFound) {
        return mainFound.title;
    }

    const subCategories = categories
        .map((c) => c.subCategories)
        // flat
        .reduce((result, array) => [...result, ...array], []);
    const subFound = subCategories.find((e) => e.id === id);
    if (subFound) {
        return subFound;
    }

    return null;
}

export async function createCategory(category) {
    if (!category.title.trim()) {
        throw new Error('category title must not be empty');
    }

    if (category.title.trim().length > 25) {
        throw new Error('category title too long');
    }

    if (!category.parent_id && !category.icon.trim()) {
        throw new Error('main category icon required');
    }

    const validatedCategory = {
        parent_id: category.parent_id || 'unset',
        title: category.title.trim(),
    };
    if (category.parent_id === null) {
        validatedCategory.icon = category.icon.trim();
    }

    await firestore.collection('categories').add(validatedCategory);
}

export async function deleteSubCategory(category) {
    const ref = await firestore
        .collection('articles')
        .where('category', '==', category.id)
        .limit(1)
        .get();
    const atLeastOneArticle = toArray(ref);
    if (atLeastOneArticle.length > 0) {
        throw new Error('van hozzárendelt hirdetés');
    }

    await firestore.collection('categories').doc(category.id).delete();
}
